import { render, staticRenderFns } from "./newRulerMark.vue?vue&type=template&id=8de3d4a0&scoped=true"
import script from "./newRulerMark.vue?vue&type=script&lang=js"
export * from "./newRulerMark.vue?vue&type=script&lang=js"
import style0 from "./newRulerMark.vue?vue&type=style&index=0&id=8de3d4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de3d4a0",
  null
  
)

export default component.exports